import React from 'react';
import { useTranslation } from 'react-i18next';

const GitHubButton: React.FC<{ label: string }> = ({ label }) => (
  <a
    href="https://github.com/CypressEra/CypressEra"
    target="_blank"
    rel="noopener noreferrer"
    className="pricing-button pricing-button-github"
  >
    <svg viewBox="0 0 16 16" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z"
      />
    </svg>
    {label}
  </a>
);

const Plans: React.FC = () => {
  const { t } = useTranslation();

  const communityFeatures = [
    t('pricing.community.features.0'),
    t('pricing.community.features.1'),
    t('pricing.community.features.2'),
    t('pricing.community.features.3'),
    t('pricing.community.features.4')
  ];

  const professionalFeatures = [
    t('pricing.professional.features.0'),
    t('pricing.professional.features.1'),
    t('pricing.professional.features.2'),
    t('pricing.professional.features.3'),
    t('pricing.professional.features.4')
  ];

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-container">
        <div className="pricing-header-section">
          <h2 className="pricing-title">{t('pricing.title')}</h2>
          <p className="pricing-subtitle">{t('pricing.subtitle')}</p>
        </div>

        <div className="pricing-grid">
          <div className="pricing-card">
            <div className="pricing-card-header">
              <h3 className="pricing-name">{t('pricing.community.name')}</h3>
              <div className="pricing-price">{t('pricing.community.price')}</div>
              <p className="pricing-description">{t('pricing.community.description')}</p>
            </div>
            <ul className="pricing-features">
              {communityFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
            <a href="https://flow.cypressera.ai" target="_blank" rel="noopener noreferrer" className="pricing-button">{t('pricing.community.button')}</a>
            <GitHubButton label={t('pricing.githubButton')} />
          </div>

          <div className="pricing-card professional">
            <div className="pricing-card-header">
              <h3 className="pricing-name">{t('pricing.professional.name')}</h3>
              <div className="pricing-price">{t('pricing.professional.price')}</div>
              <p className="pricing-description">{t('pricing.professional.description')}</p>
            </div>
            <ul className="pricing-features">
              {professionalFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
            <a href="mailto:support@cypressera.ai" className="pricing-button">{t('pricing.professional.button')}</a>
            <GitHubButton label={t('pricing.githubButton')} />
          </div>
        </div>

        <div className="pricing-faq">
          <h3 className="faq-title">{t('pricing.faq.title')}</h3>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>{t('pricing.faq.q1')}</h4>
              <p>{t('pricing.faq.a1')}</p>
            </div>
            <div className="faq-item">
              <h4>{t('pricing.faq.q2')}</h4>
              <p>{t('pricing.faq.a2')}</p>
            </div>
            <div className="faq-item">
              <h4>{t('pricing.faq.q3')}</h4>
              <p>{t('pricing.faq.a3')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Plans;
